import { DeleteButton, RaRecord, useGetList, useRecordContext, BooleanInput } from 'react-admin';
import { Grid } from '@mui/material';

export const UserDeleteWithControl = (props: any) => {

    const { source, helperText } = props;
    const record = useRecordContext<RaRecord & { email: string, deleted: boolean }>(props)
    const { email, deleted } = record!;


    const { data } = useGetList('user', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'email', order: 'DESC' },
        filter: { email, withDeleted: 1 },

    }, { enabled: deleted, })

    const isUnDeletedAlow = data?.every((el: any) => {
        return el.deleted === true;
    });

    return (
        <>
            <Grid container size={{ xs: 12, sm: 12, xl: 12 }} >
                <Grid size={{ xs: 6, sm: 4, xl: 4 }}>
                    <BooleanInput source={source}
                        helperText={helperText}
                        disabled={!isUnDeletedAlow}
                    />
                </Grid>
                <Grid size={{ xs: 6, sm: 4, xl: 4 }}>
                    <DeleteButton record={record} disabled={deleted} />
                </Grid>
            </Grid>
        </>
    );
};

